import React from "react";
import TenantManagement from "../Components/TenantManagement";

const TenantManagementPage = () => {
  return (
      <TenantManagement />
  );
};

export default TenantManagementPage;
